import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import AuthLayout from "../../layouts/AuthLayout/AuthLayout";
import { ADMIN_EMAIL, ADMIN_PASSWORD, ADMIN_SESSION_KEY } from "../../config/adminConfig";
import styles from "../Auth/AuthStyles.module.css";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    const email = formData.email.trim().toLowerCase();
    const password = formData.password;

    if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      sessionStorage.setItem(ADMIN_SESSION_KEY, "true");
      navigate(location.state?.from || "/admin/blogs", { replace: true });
      return;
    }

    setError("Those admin details are not correct.");
  };

  return (
    <AuthLayout
      title="Blog Admin"
      subtitle="Sign in to write, edit, and publish Arabella stories."
    >
      {error && <div className={styles.errorMsg}>{error}</div>}

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.inputGroup}>
          <Mail size={20} className={styles.icon} />
          <input
            type="email"
            name="email"
            placeholder="Admin email"
            value={formData.email}
            onChange={handleChange}
            required
            className={styles.input}
          />
        </div>

        <div className={styles.inputGroup}>
          <Lock size={20} className={styles.icon} />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
            className={styles.input}
          />
        </div>

        <button type="submit" className={styles.submitBtn}>
          Sign In
          <ArrowRight size={18} />
        </button>
      </form>
    </AuthLayout>
  );
};

export default AdminLoginPage;
